module.exports = __webpack_public_path__ + "7cee4fb461e477f2613aca30d4c49242.svg";